import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { eventsAPI, unwrapList } from '../../services/api';
import { LoadingPage } from '../../components/Loading';
import './Pos.css';

const AdminEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    eventsAPI.adminList()
      .then((response) => setEvents(unwrapList(response.data)))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingPage message="載入活動..." />;

  return (
    <div className="pos-card">
      <h1>活動</h1>
      <div className="pos-actions">
        <Link className="pos-btn" to="/admin/events/new">新增活動</Link>
      </div>
      <ul className="pos-list">
        {events.length === 0 && <li>暫無活動</li>}
        {events.map((event) => (
          <li key={event.id}>
            <Link to={`/admin/events/${event.id}/edit`}>{event.title}</Link>
            {' · '}
            已報名 {event.registered_count}
            {event.max_participants > 0 ? ` / ${event.max_participants}` : ' / 不限'}
            {event.allow_walk_in ? ' · 可現場報名' : ''}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AdminEvents;
